export const PROPERTY_AMENITIES = [
    'Car Parking',
    'Lift',
    'Power Backup',
    '24x7 Security',
    'CCTV',
    'Gym',
    'Swimming Pool',
    'Club House',
    'Children Play Area',
    'Park',
    'Intercom',
    'Wi-Fi',
    'Fire Safety',
    'Gas Pipeline',
    'Rain Water Harvesting'
];

export const PROPERTY_RULES = [
    'No Pets',
    'No Smoking',
    'Bachelors Allowed',
    'Family Only',
    'Vegetarians Only',
    'No Alcohol',
    'No Late Night Parties'
];
